import {
  GREENING_BRAND_TERM_DEFS,
  GreeningBrandTermVariant,
  stripMarkdownBoldEdges,
} from './greeningBrandTerms';

export type GreeningTextSegment =
  | { kind: 'text'; value: string }
  | { kind: 'brand'; value: string; variant: GreeningBrandTermVariant }
  | { kind: 'strong'; value: string };

function buildBrandRegex(): RegExp {
  const parts = GREENING_BRAND_TERM_DEFS.map((d) => `(?:${d.pattern.source})`);
  return new RegExp(parts.join('|'), 'gi');
}

const BRAND_REGEX = buildBrandRegex();

function variantForMatch(match: string): GreeningBrandTermVariant {
  const cleaned = stripMarkdownBoldEdges(match);
  const low = cleaned.toLowerCase();
  if (low.includes('oaas')) return 'oaas';
  if (low.includes('plataforma verde')) return 'verde';
  if (low.includes('plataforma azul')) return 'azul';
  if (low.includes('greenplat')) return 'greenplat';
  return 'ctre';
}

function parseStrongSegments(text: string): GreeningTextSegment[] {
  if (!text) return [];
  const segments: GreeningTextSegment[] = [];
  const strongRegex = /\*\*(.+?)\*\*/g;
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = strongRegex.exec(text)) !== null) {
    if (m.index > last) {
      segments.push({ kind: 'text', value: text.slice(last, m.index) });
    }
    segments.push({ kind: 'strong', value: m[1] });
    last = m.index + m[0].length;
  }
  if (last < text.length) {
    segments.push({ kind: 'text', value: text.slice(last) });
  }
  return segments.length ? segments : [{ kind: 'text', value: text }];
}

/** Divide texto em segmentos de marca e texto comum (inclui **negrito** genérico). */
export function parseGreeningBrandText(text: string): GreeningTextSegment[] {
  if (!text) return [];

  const output: GreeningTextSegment[] = [];
  let lastIndex = 0;
  BRAND_REGEX.lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = BRAND_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      output.push(...parseStrongSegments(text.slice(lastIndex, match.index)));
    }
    const raw = match[0];
    output.push({
      kind: 'brand',
      value: stripMarkdownBoldEdges(raw),
      variant: variantForMatch(raw),
    });
    lastIndex = match.index + raw.length;
  }

  if (lastIndex < text.length) {
    output.push(...parseStrongSegments(text.slice(lastIndex)));
  }

  return output.length ? output : parseStrongSegments(text);
}

/** Partes para linkificar e-mail antes do destaque de marca. */
export function splitByEmail(text: string, email: string): string[] {
  if (!email || !text.includes(email)) return [text];
  return text.split(email);
}
